{
  "internalError": {
    "type": "error",
    "header": "Error",
    "body": "The operation could not be completed.",
    "button": "OK"
  },
  "loginFailed": {
    "type": "error",
    "header": "Login failed",
    "body": "We could not log you on at this time. Please try again or contact us if the problem persists.",
    "button": "OK"
  },
  "userRegistrationSuccessful": {
    "type": "success",
    "header": "Registration complete",
    "body": "Your account has been successfully created. For reasons of security you will be asked to log in.",
    "button": "OK"
  },
  "userRegistrationSuccessfulWithPassword": {
    "type": "success",
    "header": "Registration complete",
    "body": "Your account has been successfully created. Click OK to proceed to your Dashboard.",
    "button": "OK"
  },
  "userConfirmationNotPossible": {
    "type": "error",
    "header": "Registration failed",
    "body": "Unfortunately we could not complete your registration at this time. Please contact our support at support@monestry.de.",
    "button": "OK"
  },
  "pressOkToContinue": {
    "type": "warning",
    "header": "Error",
    "body": "Press OK to continue.",
    "button": "OK"
  },
  "formIncomplete": {
    "type": "error",
    "header": "Form incomplete",
    "body": "Please fill out all the mandatory fields.",
    "button": "Close"
  },
  "nothingToSave": {
    "type": "success",
    "header": "Nothing to save",
    "body": "We found no changes, so saving was not necessary.",
    "button": "Close"
  },
  "localValidationFailed": {
    "type": "error",
    "header": "We found some errors",
    "body": "Please have a look at the spreadsheet again. The errors are indicated by red corners.",
    "button": "Close"
  },
  "aboutToSave": {
    "type": "warning",
    "header": "Your data are about to change",
    "body": "You are about to permanently change your data. Press OK to confirm or Cancel to abort.",
    "button": "OK",
    "button2": "Cancel"
  },
  "saveCompleted": {
    "type": "success",
    "header": "Data saved successfully",
    "body": "Your data have been saved.",
    "button": "Close"
  },
  "saveFailed": {
    "type": "error",
    "header": "Save failed",
    "body": "Unfortunately we could not save your changes. Please have a look at the error messages in comments.",
    "button": "Close"
  },
  "fileUploadSuccessful": {
    "type": "success",
    "header": "Success",
    "body": "File uploaded successfully.",
    "button": "Close"
  },
  "fileUploadFailed": {
    "type": "error",
    "header": "Unable to upload file",
    "body": "Unfortunately we could not upload the file. Please try again later.",
    "button": "Close"
  },
  "aboutToLoseData": {
    "type": "warning",
    "header": "Changes you made will be lost",
    "body": "You are about to exit Edit mode. Press OK to confirm or Cancel to abort.",
    "button": "OK",
    "button2": "Cancel"
  },
  "abandonUpload": {
    "type": "warning",
    "header": "Changes you made will be lost",
    "body": "You are about to abandon this file upload. Press OK to confirm or Cancel to abort.",
    "button": "OK",
    "button2": "Cancel"
  },
  "youAreAboutToDeleteAccount": {
    "type": "warning",
    "header": "Your data will be deleted",
    "body": "You are about to delete this account along with all its data. Press OK to confirm or Cancel to abort.",
    "button": "OK",
    "button2": "Cancel"
  },
  "youAreAboutToDeleteProject": {
    "type": "warning",
    "header": "This project will be permanently deleted",
    "body": [
      "You are about to delete this project along with all its planned transactions.",
      "Past transactions will not be deleted.",
      "Press OK to confirm or Cancel to abort."
    ],
    "button": "OK",
    "button2": "Cancel"
  },
  "youAreAboutToDeleteTransaction": {
    "type": "warning",
    "header": "This transaction will be permanently deleted",
    "body": "You are about to delete this transaction. Press OK to confirm or Cancel to abort.",
    "button": "OK",
    "button2": "Cancel"
  },
  "youAreAboutToDeleteValuation": {
    "type": "warning",
    "header": "This valuation will be permanently deleted",
    "body": "You are about to delete this valuation. Press OK to confirm or Cancel to abort.",
    "button": "OK",
    "button2": "Cancel"
  },
  "closeAccountDetails": {
    "type": "warning",
    "header": "Changes may be lost",
    "body": "If you made any changes, they will be lost. Continue?",
    "button": "OK",
    "button2": "Cancel"
  },
  "Invalid currency code": {
    "type": "error",
    "header": "Invalid currency code",
    "body": "Please enter a valid currency code.",
    "button": "Close"
  },
  "Transaction date must be in a date format": {
    "type": "error",
    "header": "Invalid transaction date",
    "body": "Transaction date must be in a date format.",
    "button": "Close"
  },
  "Transaction date is required": {
    "type": "error",
    "header": "Missing transaction date",
    "body": "Date is required for all transactions.",
    "button": "Close"
  },
  "Transaction party must be shorter than 100 characters": {
    "type": "error",
    "header": "Transaction party name too long",
    "body": "Transaction party must be shorter than 100 characters.",
    "button": "Close"
  },
  "Transaction party is required": {
    "type": "error",
    "header": "Missing transaction party.",
    "body": "A transaction party (sender or receiver) is required for all transactions.",
    "button": "Close"
  },
  "Transaction description must be shorter than 1000 characters": {
    "type": "error",
    "header": "Transaction description too long",
    "body": "Transaction description must be shorter than 1000 characters.",
    "button": "Close"
  },
  "Transaction description is required": {
    "type": "error",
    "header": "Missing transaction description",
    "body": "Transaction description is required for all transactions.",
    "button": "Close"
  },
  "Amount must be a number": {
    "type": "error",
    "header": "Amount must be a number",
    "body": "All transaction amounts must be numbers and must not contain letters.",
    "button": "Close"
  },
  "Amount is required": {
    "type": "error",
    "header": "Missing transaction amount",
    "body": "Transaction amount is mandatory for all transactions.",
    "button": "Close"
  },
  "Currency code is required": {
    "type": "error",
    "header": "Missing currency code",
    "body": "Currency code is mandatory for all transactions",
    "button": "Close"
  },
  "Foreign currency amount must be a number": {
    "type": "error",
    "header": "Foreign currency amount must be a number",
    "body": "All foreign currency amounts must be numbers and must not contain letters. Please enter foreign currency code in the Foreign Currency Symbol field",
    "button": "Close"
  },
  "Foreign exchange currency is required when a foreign currency amount is specified": {
    "type": "error",
    "header": "Foreign currency and transaction amount mismatch",
    "body": "If a foreign currency or a transaction amount are part of any transaction, then both of them must be specified in every such transaction.",
    "button": "Close"
  },
  "Currency code must be exactly 3 characters long": {
    "type": "error",
    "header": "Currency code error",
    "body": "Currency code must be exactly 3 characters long.",
    "button": "Close"
  },
  "newPasswordSuccess": {
    "type": "success",
    "header": "Success",
    "body": "Password has been changed. Please log in with your new password.",
    "button": "Close"
  },
  "youAreAboutToDeleteTemplateTransactions": {
    "type": "warning",
    "header": "Warning",
    "body": "All template transactions will be removed from your project. Do you want to continue?",
    "button": "OK",
    "button2": "Cancel"
  },
  "addTransactionManually": {
    "type": "warning",
    "header": "Warning",
    "body": "Initial purchase transaction could not be created, please add it manually.",
    "button": "OK",
    "button2": "Cancel"
  },
  "infoRedirectToProvider": {
    "type": "info",
    "header": "Log in to your bank",
    "body": [
      "We will redirect you to a secure webpage of our provider. Please log in to your bank there to approve the connection.",
      "After you have finished, you will be redirected back to Monestry.",
      "You may need to log in more than once, as there may be several ways of accessing your bank's data."
    ],
    "button": "OK",
    "button2": "Cancel"
  },
  "infoNoNewAccounts": {
    "type": "info",
    "header": "No new accounts",
    "body": "All your accounts from this bank seem to be already set up. Select a different bank.",
    "button": "OK"
  },
  "expiredCredentialsError": {
    "type": "info",
    "header": "Time to renew account access",
    "body": [
      "Access to {{accountName}} needs to be renewed. Click OK to go to your bank now.",
      "If you linked more than one account from this bank, you will only have to do it once."
    ],
    "button": "OK",
    "button2": "Cancel"
  },
  "signUpForNewsletter": {
    "type": "info",
    "header": "Thanks for signing up!",
    "body": [
      "We will typically send you one email every 1-2 months about news related to our app.",
      "We need to send you an email with a confirmation link. You can unsubscribe at any time by clicking a link in the email."
    ],
    "button": "OK",
    "button2": "Cancel"
  },
  "shareReportLinkSuccess": {
    "type": "success",
    "header": "Your link and passcode",
    "button": "OK"
  },
  "renewAccountAccessNoIbansFound": {
    "type": "error",
    "header": "IBANs not found",
    "body": [
      "Your bank sent us the following account numbers (IBANs): {{providerIbans}}.",
      "You have set up the following international accounts for automatic updates: {{monestryIbans}}.",
      "Please check if your accounts in Monestry are correctly set up and adjust them if necessary."
    ],
    "button": "OK"
  },
  "providerAccountsRemoved": {
    "type": "info",
    "header": "Accounts removed",
    "body": [
      "We did not receive data for {{list}} from your bank. Those accounts seem to have been removed.",
      "We have updated them to manually managed accounts."
    ],
    "button": "OK"
  },
  "aboutToReceiveRealEstateValuation": {
    "type": "info",
    "header": "Your first valuation",
    "body": [
      "We are about to calculate the valuation for your property. Make sure you have entered all the known details in the previous screen, as this impacts how good the valuation will be.",
      "Press OK to confirm or Cancel to abort."
    ],
    "button": "OK",
    "button2": "Cancel"
  },
  "errorsDetected": {
    "type": "error",
    "header": "Errors detected",
    "body": "We found some errors in your data. Please correct them before proceeding.",
    "button": "OK"
  }
}
